import axios from "./axios";
import _ from "lodash";

export const jsonDecode = (string) => {
  if (typeof string === "object") {
    return string;
  }
  if (string && string.length > 0) {
    try {
      return JSON.parse(string);
    } catch (e) {
      console.log("Unable to parse", string);
      return {};
    }
  }
  return {};
};
/**
 * all shortcodes used by our app
 * @param cart
 * @param type
 * @returns {({search: string, replace: string, description: string}|{search: string, replace: string, description: string}|{search: string, replace: string, description: string}|{search: string, replace: string, description: string}|{search: string, replace: string, description: string})[]}
 */
export const getShortcodeLists = (cart, type = "pre_order") => {
  let rawTrackingDetails = jsonDecode(_.get(cart, "fulfillment_details", "{}"));
  let fullfillements = _.get(rawTrackingDetails, "fulfillments", []);
  let trackingDetails = [];
  if (fullfillements.length > 0) {
    fullfillements.forEach((fullfillement) => {
      trackingDetails.push(`${fullfillement.id} (${fullfillement.url})`);
    });
  }
  let shortCodes = [
    {
      search: "{{name}}",
      replace: _.get(cart, "firstname", "") + " " + _.get(cart, "lastname", ""),
      description: "Display customer's name",
    },
    {
      search: "{{first_name}}",
      replace: _.get(cart, "firstname", ""),
      description: "Display customer's first name",
    },
    {
      search: "{{last_name}}",
      replace: _.get(cart, "lastname", ""),
      description: "Display customer's last name",
    },
    {
      search: "{{total_amount}}",
      replace: _.get(cart, "total_amount", ""),
      description: "Display checkout's total amount",
    },
    {
      search: "{{currency_code}}",
      replace: _.get(cart, "presentment_currency", ""),
      description: "Display checkouts currency code",
    },
  ];
  if (type === "post_order") {
    shortCodes.push({
      search: "{{tracking_details}}",
      replace: trackingDetails.join(", "),
      description: "Display order tracking details",
    });
    shortCodes.push({
      search: "{{order_status_url}}",
      replace: _.get(cart, "order_status_url", ""),
      description: "Display order status URL",
    });
  } else {
    shortCodes.push({
      search: "{{recovery_url}}",
      replace: _.get(cart, "recovery_url", ""),
      description: "Display checkout recovery URL",
    });
  }
  return shortCodes;
};
/**
 * Parse and replase shortcode values
 * @param message
 * @param shortCodes
 * @returns {*}
 */
export const parseShortcodes = (message, shortCodes) => {
  let replaced = message;
  if (shortCodes.length > 0) {
    shortCodes.forEach((shortcode) => {
      replaced = replaced.replace(shortcode.search, shortcode.replace);
    });
  }
  return replaced;
};
/**
 * same checkout for shortcode
 * @returns {{firstname: string, recovery_url: string, total_amount: string, presentment_currency: string, lastname: string}}
 */
export const getSampleCheckout = () => {
  return {
    firstname: "John",
    lastname: "paul",
    total_amount: "100",
    presentment_currency: "USD",
    recovery_url: "http://sampleurl.test/recover=ajxhdgjhfefrekjgehj",
  };
};
/**
 * process the response API
 * @param response
 * @private
 */
export const _processApiResponse = (
  response,
  setShop,
  setDashboard,
  setAutomations
) => {
  if (response.success) {
    setShop(_.get(response, "shop", {}));
    setDashboard(_.get(response, "dashboard", {}));
    setAutomations(response.data.data);
  }
};

// Get the automations data
export const loadAutomations = (
  setShop,
  setLoading,
  setDashboard,
  setAutomations,
  shopOrigin,
  ShopHost
) => {
  setLoading(true);
  axios
    .get(`/automations?page=1`, {
      headers: {
        shopOrigin: shopOrigin,
        xShopHost: ShopHost,
      },
    })
    .then((response) => {
      setLoading(false);
      _processApiResponse(response, setShop, setDashboard, setAutomations);
    })
    .catch((error) => {
      setLoading(false);
    });
};
